import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgReleaseNotes = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" role="img" ref={ref} {...props}><path fill="currentColor" d="m10.8 17.28-5.64-5.64 1.68-1.68 3.96 3.96L20.88 3.84A12.624 12.624 0 0 0 12 0a12 12 0 1 0 12 12 11.7 11.7 0 0 0-1.68-6.12z" /></svg>;
const ForwardRef = forwardRef(SvgReleaseNotes);
export default ForwardRef;